import React, { useState } from 'react'
import { GoogleSigninButtonForcus, GoogleSigninButtonNormal, GoogleSigninButtonPressed } from 'icons'

interface GoogleLoginButtonProps {
    onClick: () => void
}

type ButtonStatus = 'PRESSED' | 'NORMAL' | 'FORCUS'
function GoogleLoginButton(props: GoogleLoginButtonProps) {
    const [state, setState] = useState<ButtonStatus>('NORMAL')
    const { onClick } = props
    return (
        <div
            style={{ marginTop: "5px" }}
            onFocus={() => setState('FORCUS')}
            onBlur={() => setState('NORMAL')}
            onMouseDown={() => setState('PRESSED')}
            onMouseUp={onClick}
            onMouseEnter={() => setState('FORCUS')}
            onMouseOut={() => setState('NORMAL')}
            onMouseLeave={() => setState('NORMAL')}
        >
            {state === 'NORMAL' && (<GoogleSigninButtonNormal />)}
            {state === 'PRESSED' && (<GoogleSigninButtonPressed />)}
            {state === 'FORCUS' && (<GoogleSigninButtonForcus />)}
        </div>
    )
}

export default GoogleLoginButton
